<template>
  <div class="check-ban-operat-modal">
    <Modal
      class="hide-load-btn"
      @on-cancel="cancelClick"
      @on-ok="sureClick"
      :loading="modalLoading"
      :ok-text="$t('views.public.sure')"
      :cancel-text="$t('views.public.cancel')"
      v-model="showModal"
      :title="$t('components.publicCheckBan.checkBan')">
      <i-input v-model="reason" :placeholder="$t('components.publicCheckBan.enterUserName')"></i-input>
    </Modal>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    name: "check-ban-operat-modal",
    components: {},
    data() {
      return {
        reason: '',
        showModal: false,
        modalLoading: true,
      }
    },
    computed: {
      ...mapGetters([
        'showBanOperatFlag',
      ]),
    },
    created() {
    },
    methods: {
      sureClick() {
        const reason = this.reason.trim();
        if (!reason) {
          this.modalLoading = true;
          this.$Message.error(this.$selfGlobal.$globalI18n.tc('components.publicCheckBan.nameNotNull'));
          return;
        } else {
          this.modalLoading = false;
        }
        this.$http.checkOperateUser({
          operate_count: this.showBanOperatFlag.count,
          operate_keyword: this.reason,
        }).then((res) => {
          if (Number(res.status) == 200) {
            if (this.showBanOperatFlag.type === 'checkbox') this.$Message.success(this.$i18n.tc('components.publicCheckBan.checkSuccess'));
            this.$selfGlobal.$globalMethodArr.forEach(methodItem => {
              methodItem.method && methodItem.method();
            });
          } else {
            this.$Message.error($t('components.publicCheckBan.checkError'))
          }
          this.modalLoading = true;
          this.showModal = false;
        }).catch(err => {
          this.modalLoading = true;
        })
        // this.$store.commit('setShowPasswordFlag', false);
      },
      cancelClick() {
      },
      resetOperate() {
        this.$store.commit('setShowBanOperatFlag', this.$store.state.app.initBanOperatFlag);
        this.$selfGlobal.$globalMethodArr = [];
        this.reason = '';
      }
    },
    watch: {
      showBanOperatFlag(newVal) {
        if (newVal.show) {
          this.showModal = true;
        }
      },
      // 关闭时初始化
      showModal(newVal) {
        if (newVal === false) {
          this.resetOperate(); // 不能放最外面，需要等上面的forEach执行完之后才能修改，不然会一直弹出输入框
        }
      },
    }
  }
</script>
<style scoped lang="scss">
  @function r($px) {
    @return $px/100*1rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/publicCheckBan/publicCheckBan.vue